export default __webpack_public_path__ + "static/NeffSans-Bold-8018d3ee009af9a61af22f0d831c2244.ttf";